"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";

/** Syncs NextAuth session into localStorage for legacy UI (navbar, admin). */
export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status !== "authenticated" || !session?.user?.email) return;

    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("userEmail", session.user.email);
    localStorage.setItem("userName", session.user.name || "User");
    localStorage.setItem(
      "userRole",
      (session.user as { role?: string }).role || "user"
    );
  }, [session, status]);

  return <>{children}</>;
}
